import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Determine if we're on the homepage or not
  const isHomePage = window.location.pathname === '/';
  const navItems = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Why Attend',
    href: '#why-attend'
  }, {
    name: 'Agenda',
    href: '#agenda'
  }, {
    name: 'Venue',
    href: '#venue'
  }, {
    name: 'Register',
    href: '#register'
  }, {
    name: 'Sponsorship',
    href: '/sponsorship'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (isHomePage && href.startsWith('#')) {
      e.preventDefault();
      const element = document.getElementById(href.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setIsMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#FFF8DC] shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-104">
      <div className="container mx-auto px-4 md:px-6" data-id="element-105">
        <div className="flex items-center justify-between" data-id="element-106">
          <div className="flex items-center" data-id="element-107">
            <Link to="/" data-id="element-108">
              <h1 className={`text-xl font-bold font-serif tracking-wide ${isScrolled ? 'text-[#8B4513]' : 'text-white'}`} style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-109">
                COMMERCE CFO ROUNDTABLE - AUSTIN
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-110">
            {navItems.map(item => <Link key={item.name} to={item.href.startsWith('#') ? '/' : item.href} onClick={e => handleNavClick(e, item.href)} className={`font-medium hover:text-[#D2691E] transition-colors ${isScrolled ? 'text-[#556B2F]' : 'text-white'}`} data-id="element-111">
                {item.name}
              </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-112">
            {isMenuOpen ? <X className={isScrolled ? 'text-[#8B4513]' : 'text-white'} size={24} data-id="element-113" /> : <Menu className={isScrolled ? 'text-[#8B4513]' : 'text-white'} size={24} data-id="element-114" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden absolute left-0 right-0 top-full bg-[#FFF8DC] shadow-md p-4 border-t border-[#D2691E]" data-id="element-115">
            <div className="flex flex-col space-y-4" data-id="element-116">
              {navItems.map(item => <Link key={item.name} to={item.href.startsWith('#') ? '/' : item.href} onClick={e => handleNavClick(e, item.href)} className="text-[#556B2F] font-medium hover:text-[#D2691E] transition-colors" data-id="element-117">
                  {item.name}
                </Link>)}
            </div>
          </div>}
      </div>
    </header>;
}